
const Image =(props) => {
    return(
        <div>
            <img src={props.imageUrl} alt={props.name}/>
        </div>
    )
}

export default Image;